import {z} from 'zod'
import {createNumericKeyRecordSchema} from '../OptionalNumericKeyRecordSchema.ts'
import {createPartialStrictObjectSchemaWithAtLeastOneProperty} from '../PartialStrictObjectSchema.ts'
import {validateState} from '../ValidateState.ts'
import {TileHexType} from './TileHexState.ts'

export const fogTileDiceNumber: number = 0

export const fogTileGroupStateSchema = z
    .object({
        fogTileIndexes: z.array(z.number().int().min(0)),
        possibleTileTypes: z.array(z.enum(TileHexType)),
        possibleDiceNumbers: z.array(z.number().int().min(2).max(12)),
    })
    .strict()

export type FogTileGroupState = z.infer<typeof fogTileGroupStateSchema>

export function validateFogTileGroupState(data: unknown) {
    return validateState(fogTileGroupStateSchema, data)
}

export const fogTileGroupStatesSchema = createNumericKeyRecordSchema(fogTileGroupStateSchema)
export type FogTileGroupStates = z.infer<typeof fogTileGroupStatesSchema>

export function validateFogTileGroupStates(data: unknown) {
    return validateState(fogTileGroupStatesSchema, data)
}

export const fogTileGroupStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(fogTileGroupStateSchema)

export type FogTileGroupStatePartial = z.infer<typeof fogTileGroupStatePartialSchema>

export function validateFogTileGroupStatePartial(data: unknown) {
    return validateState(fogTileGroupStatePartialSchema, data)
}

export const fogTileGroupStatesPartialSchema = createNumericKeyRecordSchema(fogTileGroupStatePartialSchema, {
    requireAtLeastOneEntry: true,
})
export type FogTileGroupStatesPartial = z.infer<typeof fogTileGroupStatesPartialSchema>

export function validateFogTileGroupStatesPartial(data: unknown) {
    return validateState(fogTileGroupStatesPartialSchema, data)
}
